import { BackendService } from './BackendService';
import { IAppNotification } from '@/types/notifications.types';

export class NotificationService extends BackendService {

    public async getAll(): Promise<IAppNotification[]> {
        const res = await this.jsonClient.get<IAppNotification[]>('/app-notifications');
        return res.data;
    }

    public async getUnreadCount(): Promise<number> {
        const res = await this.jsonClient.get<number>('/app-notifications/unread-count');
        return res.data;
    }

    public async markRead(id: number): Promise<void> {
        await this.jsonClient.put(`/app-notifications/${id}/read`, {});
    }

    public async markUnread(id: number): Promise<void> {
        await this.jsonClient.put(`/app-notifications/${id}/unread`, {});
    }

    public async delete(id: number): Promise<void> {
        await this.jsonClient.delete(`/app-notifications/${id}`);
    }

}

export default new NotificationService();
